export default "__VITE_ASSET__BIh75NoA__"